enum ActAction {
  APPROVE = "approve",
  REVOKE = "revoke",
}

export default ActAction;
